import SliceNames from '@/state/enum';
import getRefIndex from '@/state/selectors/ref/get-ref-index';
import { RefActions } from '@/state/slices/ref/typings';
import { IStore, SetState } from '@/state/slices/typings';

const refActionsCreator = (
	set: SetState<IStore>,
	get: () => IStore,
): RefActions => {
	return {
		[SliceNames.REF]: {
			addRef: (key: string, ref: React.RefObject<any>, group: string) => {
				const refIndex = getRefIndex(get(), key);

				if (refIndex > -1) {
					set(
						(state) => ({
							...state,
							[SliceNames.REF]: {
								...state[SliceNames.REF],
								refs: [
									...state[SliceNames.REF].refs.slice(
										0,
										refIndex,
									),
									{ key, ref, group },
									...state[SliceNames.REF].refs.slice(
										refIndex + 1,
									),
								],
							},
						}),
						undefined,
						{
							type: `${SliceNames.REF}/addRef`,
							key,
							ref,
							group,
						},
					);
				} else {
					set(
						(state) => ({
							...state,
							[SliceNames.REF]: {
								...state[SliceNames.REF],
								refs: [
									...state[SliceNames.REF].refs,
									{ key, ref, group },
								],
							},
						}),
						undefined,
						{
							type: `${SliceNames.REF}/addRef`,
							key,
							ref,
							group,
						},
					);
				}
			},
			rmRefByKey: (key: string) => {
				set(
					(state) => ({
						...state,
						[SliceNames.REF]: {
							...state[SliceNames.REF],
							refs: state[SliceNames.REF].refs.filter(
								(item) => item.key !== key,
							),
						},
					}),
					undefined,
					{
						type: `${SliceNames.REF}/rmRefByKey`,
						key,
					},
				);
			},
			rmRefsByGroup: (group: string) => {
				set(
					(state) => ({
						...state,
						[SliceNames.REF]: {
							...state[SliceNames.REF],
							refs: state[SliceNames.REF].refs.filter(
								(item) => item.group !== group,
							),
						},
					}),
					undefined,
					{
						type: `${SliceNames.REF}/rmRefsByGroup`,
						group,
					},
				);
			},
		},
	};
};

export default refActionsCreator;
